export default {"src":"/_next/static/media/TractorIcon.9ab17254.svg","height":80,"width":80};